<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" type="success" plain @click="improtSt" v-if="!isMB">导入学生</el-button>
        <el-button size="mini" type="primary" plain @click="exportSt" v-if="!isMB">导出学生</el-button>
        <!-- <el-button size="mini" type="warning" plain @click="improtStPic" v-if="!isMB">导入图片</el-button>
        <el-button size="mini" type="primary" @click="create">添加</el-button> -->
        <!-- <el-button size="mini" type="primary" @click="sync" :loading="bnLoading">同步</el-button> -->
        <el-button size="mini" type="success" plain @click="improtStatus" v-if="!isMB">更新账号状态</el-button>
        <el-button size="mini" type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" :width="isMB?60:80">
          <template slot-scope="{row}">
            <el-button type="text" @click="edit(row)" size="medium" icon="el-icon-edit-outline" title="编辑"></el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <import-dialog ref="importDialog" @upload-success="reload" />
    <import-status-dialog ref="importStatusDialog" @upload-success="reload" />
    <!-- <import-pic-dialog ref="importPicDialog" @upload-success="reload" /> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/st/student/list";
import editDialog from "@/components/st/student/editDialog";
import importDialog from "@/components/st/student/importDialog";
import importStatusDialog from "@/components/st/student/importStatusDialog";
// import importPicDialog from "@/components/st/student/importPicDialog";

export default {
  name: "student",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
    importStatusDialog
    // importPicDialog,
  },
  data() {
    return {
      api: require("@/api/st/student").default,
      isMB: this.$store.state.isMB,
      bnLoading: false,
    };
  },
  methods: {
    sync() {
      this.bnLoading = true
      this.api.sync().then(res => {
      this.bnLoading = false
        if(res.Code==0) {
          this.$message.success("同步成功")
          this.reload()
        } else {
          // this.$message.error(res.Msg)
          this.$message.error("同步失败")
        }
      })
    },
    improtSt() {
      this.$refs.importDialog.open();
    },
    exportSt() {
      this.$refs.list.export();
    },
    improtStatus() {
      this.$refs.importStatusDialog.open();
    },
  //   improtStPic() {
  //     this.$refs.importPicDialog.open();
  //   },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.StudentId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.info-box {
  display: flex;
  display: -webkit-flex;
  display: -webkit-inline-flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
</style>